"use strict";

exports.__esModule = true;
exports.default = void 0;
var maxDaysPerMonth = {
  1: 31,
  2: 29,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31
};

var getDayValue = function getDayValue(value, month) {
  var num = +value;

  if (!value && value !== 0) {
    return '';
  }

  if (num < 0) {
    return 1;
  }

  if (num > maxDaysPerMonth[month]) {
    return maxDaysPerMonth[month];
  }

  return value;
};

var _default = getDayValue;
exports.default = _default;